// Pack de langue française
export default {
  // Commun
  common: {
    learnMore: 'En savoir plus',
    viewDetails: 'Voir les détails',
    backToTop: 'Retour en haut',
    loading: 'Chargement...',
    confirmSubmit: 'Confirmer la soumission',
    backToHome: "Retour à l'accueil",
    backToPrevious: 'Retour',
    category: 'Catégorie',
    all: 'Tout',
    wechatQrcode: 'Compte officiel WeChat',
    emailAddress: 'Adresse e-mail',
    copySuccess: 'Copié avec succès',
    copy: 'Copier',
    noData: 'Aucune donnée',
    noDataDesc: 'Aucun contenu disponible dans cette catégorie',
  },

  // Langue
  language: {
    zhCN: '简体中文',
    en: 'English',
    ja: '日本語',
    es: 'Español',
    fr: 'Français',
    selectLanguage: 'Sélectionner la langue',
  },

  // Menu de navigation
  nav: {
    home: "Page d'accueil",
    aboutUs: 'À propos de nous',
    companyIntro: "Présentation de l'entreprise",
    awardsHonors: 'Prix et titres',
    products: 'Centre de produits',
    coronaryBypass: 'Pontage coronarien (CABG)',
    severeHeartDisease: 'Maladies cardiaques graves et circulation extracorporelle',
    vascularIntervention: 'Intervention vasculaire',
    academic: 'Informations académiques',
    newProducts: 'Nouveaux produits',
    clinicalRelated: 'Lié à la clinique',
    academicFrontier: 'Frontière académique',
    news: "Actualités de l'entreprise",
    newsExpress: 'Actualités express',
    awards: 'Prix',
    financingAnnouncement: 'Annonce de financement',
    contactUs: 'Nous contacter',
  },

  // Page d'accueil
  home: {
    // Bannière
    bannerSlogan: 'Là où YueWei arrive, le complexe se simplifie',
    bannerSloganHighlight: 'simplifie',

    // Solutions de produits
    productSolutions: 'Solutions de produits',
    productCenter: 'Centre de produits',
    coronaryBypass: 'CABG',
    severeHeartDisease: 'Maladie cardiaque grave',
    severeHeartDiseaseAndECMO: 'Maladies cardiaques graves et circulation extracorporelle',
    severeHeartDiseaseMobile: 'Maladie cardiaque grave<br>et circulation extracorporelle',
    vascularIntervention: 'Intervention vasculaire',

    // Notre vision
    ourVision: 'Notre vision',
    aboutUs: 'À propos de nous',
    visionTitle1: 'INNOVATION',
    visionText1: 'NAÎT DES BESOINS CLINIQUES',
    visionTitle2: 'INGÉNIOSITÉ',
    visionText2: 'BÂTIT UN AVENIR SAIN',

    // Histoire de développement
    developmentHistory: 'Histoire de développement',
    timeline: {
      year2021: 'Yuewei Medical fondée à Pékin',
      year2023_1: 'Entreprise de haute technologie de Zhongguancun',
      year2023_2: 'Entreprise de haute technologie de niveau national',
      year2023_3: 'PMI technologique reconnue par le ministère de la Science et de la Technologie',
      year2024_1: 'PME spécialisée et innovante de Beijing',
      year2024_2: "Entreprise leader annuelle (industrie) du Forum d'entreprises de Boao",
      year2024_3: "Association des Fonds de Beijing <Cas d'excellence d'investissement durable 2024>",
    },

    // Actualités de l'entreprise
    newsCenter: "Centre d'actualités",
    enterpriseDynamics: "Actualités de l'entreprise",
    corporateHonors: "Honneurs de l'entreprise",
    capitalDynamics: 'Dynamiques de capital',
    strategicCooperation: 'Coopération stratégique',
    newsTitle: "Yuewei Medical obtient près de 100 millions de RMB dans le financement de série A++ pour accélérer le processus complet de diagnostic et de traitement des maladies cardiaques coronaires graves",
    newsCategory: 'Annonce de financement',
    newsDate: '2025/12/07',
    newsDesc: "Publier le développement de l'entreprise, les projets de coopération et les informations externes importantes",

    // Informations académiques
    academicInfo: 'Informations académiques',
    clinicalResearch: 'Recherche clinique',
    literatureInterpretation: 'Interprétation de littérature',
    academicPromotion: 'Promotion académique',
    academicTitle1: 'Nouveaux produits',
    academicTitle2: 'Lié à la clinique',
    academicTitle3: 'Frontière académique',
    academicDesc1: 'Redéfinir la vitesse et la précision | Nouveau stabilisateur cardiaque YueWei officiellement lancé',
    academicDesc2: "IA propulsant le diagnostic et traitement de précision des maladies coronariennes - Perspectives 2026",
    academicDesc3: 'Aperçus des nouvelles perspectives cliniques mondiales - Le 12e ICEF inauguré grandement à Beijing',
    academicDetailText: "Se concentrer sur la recherche clinique liée aux produits, les preuves académiques et le contenu d'échange académique",
  },

  // Page À propos de nous
  about: {
    aboutYuewei: 'À propos de YueWei',
    mission: 'Mission',
    missionText1: 'Devenir un partenaire de confiance',
    missionText2: 'en chirurgie cardiovasculaire',
    vision: 'Vision',
    visionText1: 'INNOVATION',
    visionText2: 'NAÎT DES BESOINS CLINIQUES',
    visionText3: 'INGÉNIOSITÉ',
    visionText4: 'BÂTIT UN AVENIR SAIN',
    values: 'Valeurs',
    valuesText1: "Par l'innovation continue",
    valuesText2: 'Habiliter les chirurgiens,',
    valuesText3: 'Pour plus de patients',
    valuesText4: "Ouvrir de nouveaux espoirs de vie",
    awardsAndTitles: 'Prix et titres',
    companyIntro: "Yuewei Medical a été fondée en septembre 2021 par des chirurgiens cardiaques de l'hôpital Anzhen avec des cadres supérieurs d'entreprises leaders de dispositifs médicaux nationales et internationales. C'est une entreprise de haute technologie axée sur la R&D, la fabrication et la vente de dispositifs médicaux de chirurgie cardiovasculaire. L'entreprise a été reconnue comme Entreprise Nationale de Haute Technologie et PME « Spécialisée et Innovante » de Beijing.",
    productIntro: 'Les produits principaux actuels sont divisés en trois secteurs majeurs:',
    productLine1Title: 'Secteur de Chirurgie des Maladies Coronaires',
    productLine1Desc: ', avec des débitmètres sanguins coronaires et des stabilisateurs cardiaques de nouvelle génération comme noyau, déployant près de dix instruments chirurgicaux, réalisant une couverture complète des consommables de haute valeur en chirurgie coronaire;',
    productLine2Title: 'Secteur des Maladies Cardiaques Graves et Circulation Extracorporelle',
    productLine2Desc: ', avec la technologie et les matériaux de canule haut de gamme développés par Yuewei comme noyau, déployant plusieurs premiers produits nationaux incluant des canules artérioveineuses fémorales à paroi mince et des canules veineuses à double lumière;',
    productLine3Title: 'Secteur de Traitement de la Thrombose Veineuse Profonde',
    productLine3Desc: ', ce secteur est une conception stratégique que l\'entreprise a commencé par des acquisitions en 2024, déployant deux dispositifs médicaux innovants autour du traitement de la thrombose veineuse profonde.',
    companyMotto: "Depuis sa création, Yuewei Medical a toujours suivi la philosophie de développement \"L'innovation découle des besoins cliniques, l'ingéniosité construit un futur sain\", et s'engage à devenir un leader dans les instruments chirurgicaux cardiovasculaires graves de Chine.",
  },

  // Page Prix et Titres
  prize: {
    title: 'Prix et Titres',
    aboutYuewei: 'À propos de YueWei',
    viewDetails: 'Voir les détails',
    awards: {
      award1: {
        year: '2023',
        title: 'Entreprise de Haute Technologie de Zhongguancun',
      },
      award2: {
        year: '2023',
        title: 'Entreprise Nationale de Haute Technologie',
      },
      award3: {
        year: '2023',
        title: 'PME Technologique du Ministère de la Science',
      },
      award4: {
        year: '2024',
        title: 'PME Spécialisée et Innovante de Beijing',
      },
      award5: {
        year: '2024',
        title: 'Entreprise Leader Annuelle du Forum Boao',
      },
      award6: {
        year: '2024',
        title: 'Association des Fonds de Beijing',
        subtitle: "<Cas d'Excellence d'Investissement Durable 2024>",
      },
    },
  },

  // Page Produits
  products: {
    productDetails: 'Détails du produit',
    productCenter: 'Centre de produits',
    categories: {
      coronaryBypass: 'Pontage Coronarien',
      severeHeartDisease: 'Maladie Cardiaque Grave et ECMO',
      vascularIntervention: 'Intervention Vasculaire',
    },
    items: {
      heartStabilizer: {
        name: 'Stabilisateur Cardiaque',
        code: '[N° d\'enregistrement] JXYZ 20242030034',
      },
      coronaryImaging: {
        name: "Logiciel d'Imagerie d'Angiographie Coronaire",
        code: '[N° d\'enregistrement] JXYZ 20242210076',
      },
      endoscopeVessel: {
        name: 'Système de Prélèvement Vasculaire Endoscopique*',
        code: '*Ce produit n\'est pas encore disponible en Chine',
      },
      proximalAnastomosis: {
        name: "Système d'Anastomose Proximale**",
        code: '*Ce produit n\'est pas encore disponible en Chine',
      },
      ultrasonicFlowmeter: {
        name: 'Débitmètre Sanguin Ultrasonique (TTFM+ECUS)*',
        code: '*Ce produit n\'est pas encore disponible en Chine',
      },
    },
  },

  // Page Détail Produit
  productDetail: {
    productCenter: 'Centre de produits',
    title: 'Stabilisateur Cardiaque',
    subtitle: 'Stabilisateur Cardiaque Modulaire et Multifonctionnel',
    code: '[N° d\'enregistrement] JXYZ 20242030034',
    description: "Ceci est le contenu de texte enrichi d'introduction du produit maintenu dans le backend. Ceci est le contenu de texte enrichi d'introduction du produit maintenu dans le backend. Ceci est le contenu de texte enrichi d'introduction du produit maintenu dans le backend.",
  },

  // Page Nous contacter
  contact: {
    title: 'Nous contacter',
    yourName: 'Nom',
    enterYourName: 'Nom',
    yourPhone: 'Téléphone',
    enterYourPhone: 'Téléphone',
    yourCompany: 'Entreprise',
    enterYourCompany: 'Entreprise',
    yourMessage: 'Message',
    enterYourMessage: 'Message',
    privacyAgreement: "J'accepte que Yuewei Medical traite mes données personnelles et je déclare avoir lu la politique de confidentialité",
    submitSuccess: 'Soumission réussie',
    validation: {
      nameRequired: 'Veuillez entrer votre nom',
      phoneRequired: 'Veuillez entrer votre numéro de téléphone',
      companyRequired: 'Veuillez entrer votre entreprise',
      messageRequired: 'Veuillez entrer votre message',
      agreeRequired: 'Veuillez accepter la politique de confidentialité',
    },
    companyName: 'Beijing YueWei Medical Technology Co., Ltd.',
    address: 'Centre Créatif Huashang, 18 Rue Keyuan, Zone de Développement Économique, District Daxing, Pékin',
  },

  // Page Actualités
  news: {
    title: "Annonces d'Actualités",
    categories: {
      all: 'Tout',
      newsExpress: 'Actualités Express',
      awards: 'Prix',
      financing: 'Annonces de Financement',
    },
  },

  // Page Académique
  academic: {
    title: 'Innovation Médicale',
    categories: {
      all: 'Tout',
      newProducts: 'Nouveaux Produits',
      clinical: 'Lié à la Clinique',
      frontier: 'Frontière Académique',
    },
  },

  // Pied de page
  footer: {
    companyName: 'Beijing YueWei Medical Technology Co., Ltd.',
    companyNameEn: 'Beijing Yuewei Medical Technology Co., Ltd',
    address: 'Adresse: Centre Créatif Huashang, 18 Rue Keyuan, Zone de Développement Économique, District Daxing, Pékin',
    addressShort: 'Adresse: 18 Rue Keyuan, District Daxing, Pékin',
    copyright: 'Copyright © 2025 Beijing YueWei Medical Technology Co., Ltd.',
    icp: 'Enregistrement ICP: ',
    icpNumber: 'Jing ICP Bei 2025155672-1',
    securityNumber: 'Jing Réseau Public Sécurisé 11011502039384',
    medicalLicense: "Numéro d'enregistrement du service d'information réseau des dispositifs médicaux: ",
    medicalLicenseNumber: "(Jing) Enregistrement d'information de dispositifs médicaux en ligne (2024) N° 00322",
  },
}
